export const selectBlockedAttendees = ({ blockedAttendees }) =>
  blockedAttendees.map((item) => item);



// WEBPACK FOOTER //
// ./redux/selectors/blockedAttendees.js